import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserListItemComponent } from './user-list-item.component';
import { TextAvatarModule } from '../text-avatar/text-avatar.module';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from 'src/app/directives/directives.module';

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      TextAvatarModule,
      IonicModule,
      DirectivesModule
  ],
  declarations: [UserListItemComponent],
  exports: [UserListItemComponent]
})

export class UserListItemModule { }